import { get, put } from "helpers/api_helper";

export const apiGetThresholdSetting = () => {
  return get(`/record/setting/`);
};

export const apiUpdateThresholdSetting = (params) => {
  return put(`/record/setting/`, params);
};
